import React, { useEffect } from "react";
import Select from "react-select";
import PropTypes from "prop-types";
import ErrorInput from "../../../../components/ui/ErrorInput";
import { useEditarCambioUnidad, findTemporisOption } from "./useEditarCambioUnidad";
import { FIELD_LABEL_STYLE } from "../ModalEditarSolicitud";

export const EditarCambioUnidad = ({ formik, solicitud, tipo, onLoadingChange }) => {
  const { arrTemporis, arrPlanHorario, cargandoTemporis } = useEditarCambioUnidad(formik.values.cod_sap_nuevo_cargo, formik, solicitud);

  useEffect(() => {
    if (onLoadingChange) {
      onLoadingChange(Boolean(cargandoTemporis));
    }
  }, [cargandoTemporis, onLoadingChange]);

  const getUnitValue = () => {
    if (!formik.values.nueva_unidad_organizativa) return null;
    return (
      findTemporisOption(arrTemporis, {
        val: formik.values.nueva_unidad_organizativa,
        desc: formik.values.descripcion_unidad_temporis,
        unitId: typeof formik.values.nueva_unidad_organizativa === "object"
          ? formik.values.nueva_unidad_organizativa.IdUnidadorganizativa
          : formik.values.nueva_unidad_organizativa,
        cargoId: typeof formik.values.nueva_unidad_organizativa === "object"
          ? formik.values.nueva_unidad_organizativa.IdCargogenerico
          : null,
      }) || null
    );
  };

  const getPlanValue = () => {
    const val = formik.values.nuevo_plan_horario;
    if (!val) return null;
    const code = String(val).includes("|") ? String(val).split("|")[0] : String(val);
    const planOpts = arrPlanHorario.map((el) => ({
      label: el.Planhorarionombre,
      value: `${el.Planhorariocodigoerp}|${el.Planhorarionombre}`,
    }));

    return (
      planOpts.find((opt) => opt.value.startsWith(`${code}|`) || opt.value === val) || null
    );
  };

  const planOptions = arrPlanHorario.map((el) => ({
    label: el.Planhorarionombre,
    value: `${el.Planhorariocodigoerp}|${el.Planhorarionombre}`,
  }));

  return (
    <>
      <div>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <label htmlFor="nueva_unidad_organizativa" style={{ ...FIELD_LABEL_STYLE, marginBottom: 0 }}>
            NUEVA UNIDAD ORGANIZATIVA - CARGO (TEMPORIS) <span className="text-danger">*</span>
          </label>
          {formik.errors.nueva_unidad_organizativa && formik.touched.nueva_unidad_organizativa && (
            <ErrorInput touched={formik.touched.nueva_unidad_organizativa} error={formik.errors.nueva_unidad_organizativa} />
          )}
        </div>
        <Select
          id="nueva_unidad_organizativa"
          name="nueva_unidad_organizativa"
          className="selectDos"
          isDisabled={!formik.values.cod_sap_nuevo_cargo && tipo === 1}
          isLoading={cargandoTemporis}
          value={getUnitValue()}
          onChange={(e) => {
            formik.setFieldValue("nueva_unidad_organizativa", e?.value || "");
            formik.setFieldValue("nuevo_plan_horario", "");
            formik.setFieldValue("descripcion_unidad_temporis", e?.label || "");
          }}
          placeholder="---Seleccione---"
          isClearable={true}
          menuPlacement="auto"
          menuPosition="fixed"
          maxMenuHeight={220}
          classNamePrefix="limpiarSelect"
          options={arrTemporis}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </div>

      <div>
        <div className="d-flex justify-content-between align-items-center mb-1">
          <label htmlFor="nuevo_plan_horario" style={{ ...FIELD_LABEL_STYLE, marginBottom: 0 }}>
            NUEVO PLAN HORARIO <span className="text-danger">*</span>
          </label>
          {formik.errors.nuevo_plan_horario && formik.touched.nuevo_plan_horario && (
            <ErrorInput touched={formik.touched.nuevo_plan_horario} error={formik.errors.nuevo_plan_horario} />
          )}
        </div>
        <Select
          id="nuevo_plan_horario"
          name="nuevo_plan_horario"
          className="selectDos"
          isDisabled={(!formik.values.cod_sap_nuevo_cargo && tipo === 1) || cargandoTemporis}
          isLoading={cargandoTemporis}
          value={getPlanValue()}
          onChange={(e) => {
            formik.setFieldValue("nuevo_plan_horario", e?.value || "");
          }}
          placeholder="---Seleccione---"
          isClearable={true}
          menuPlacement="auto"
          menuPosition="fixed"
          maxMenuHeight={220}
          classNamePrefix="limpiarSelect"
          options={planOptions}
          menuPortalTarget={typeof document !== "undefined" ? document.body : null}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
        />
      </div>
    </>
  );
};

EditarCambioUnidad.propTypes = {
  formik: PropTypes.object.isRequired,
  solicitud: PropTypes.object,
  tipo: PropTypes.number,
  onLoadingChange: PropTypes.func,
};
